import axios from 'axios';

export const getAuthData = async (login: string, password: string) => (await axios({
  method: 'post',
  url: 'https://fullimpact.training/wp-json/jwt-auth/v1/token',
  timeout: 5000,
  data: {
    username: login,
    password: password
  }
}).catch(err => err.response))?.data;

export const getUserData = async (token: string, email: string) => {
  const userData = (await axios({
    method: 'get',
    url: `https://fullimpact.training/wp-json/wp/v2/users/?search=${email}&context=edit`,
    timeout: 5000,
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }).catch(err => {
    console.log('USER DATA ERROR: ', err);
    return err.response;
  }))?.data;

  console.log('USER DATA: ', userData);

  return userData?.length === 1
    ? {
      token: token,
      id: userData[0].id,
      username: userData[0].username,
      firstName: userData[0].first_name,
      lastName: userData[0].last_name,
      email: userData[0].email,
      nickname: userData[0].nickname,
      roles: userData[0].roles,
      registeredDate: userData[0].registered_date
    }
    : {
      token,
      email,
      roles: []
    };
};

export const validateJwt = async (token: string) => {
  const validation = (await axios({
    method: 'post',
    url: 'https://fullimpact.training/wp-json/jwt-auth/v1/token/validate',
    timeout: 5000,
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }).catch(err => err.response))?.data;

  return validation.data.status === 200;
};